import { getAPIUrl } from "@/stores/ApolloClient/helpers/getAPIUrl.ts";
import { getLocale } from "@/stores/ApolloClient/helpers/getLocale.ts";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const httpLink = createHttpLink({ uri: getAPIUrl() });

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage/other source if it exists
  // const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them

  return {
    // eslint-disable-next-line
    headers: {
      ...headers,
      locale: getLocale(),
      // authorization: token ?? `Bearer ${token}`,
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
